import { useTranslation } from "react-i18next";
import { ContentPanel, PageBanner, UnorderedList } from "../components";
import { OccupationalHealthServicesBanner } from "../images";
import { ContactUsButton } from "../components/ContactUsButton/ContactUsButton";

export const PublicHealthcareServices = () => {
    const { t } = useTranslation();
        const keyFeatures = t('publicHealthcareServices.keyFeatures', { returnObjects: true }) as string[]
    
        return (
            <div>
            <PageBanner image={OccupationalHealthServicesBanner} title={t('publicHealthcareServices.bannerTitle')} />
    
                <ContentPanel headerText={t('publicHealthcareServices.header')}>
                    <p className="mb-5">{t('publicHealthcareServices.paragraph1')}</p>
    
                    <h4 className="text-xl mb-5">{t('publicHealthcareServices.ourCoreExpertise')}</h4>
    
                    <UnorderedList items={keyFeatures} hasCheckmark={false} />
    
                    <ContactUsButton title={t('publicHealthcareServices.contactUsTitle')} />
                </ContentPanel>
            </div>
        )
}